import React from 'react';
import { Link } from 'react-router-dom';
import './AdBanner.css';

const AdBanner = () => {
  return (
    <section className="promo-section">
      <div className="promo-container">
        <div className="promo-card">
          <div className="promo-card-content">
            <span className="promo-card-label">REKLAM ALANI</span>
            <p className="promo-card-text">Burada reklam verin - İşletmenizi binlerce kişiye tanıtın</p>
            <Link to="/iletisim" className="promo-card-btn">Reklam Ver</Link>
          </div>
          <div className="promo-card-deco">
            <div className="promo-card-circle promo-card-circle--1"></div>
            <div className="promo-card-circle promo-card-circle--2"></div>
          </div>
        </div>

        <div className="promo-card promo-card--supplier">
          <div className="promo-card-content">
            <span className="promo-card-label promo-card-label--supplier">TEDARİKÇİ</span>
            <p className="promo-card-text">Restoranlarımız için ürün ve hizmet tedarik etmek ister misiniz?</p>
            <Link to="/tedarikci-basvurusu" className="promo-card-btn">Tedarikçi Başvurusu</Link>
          </div>
          <div className="promo-card-deco">
            <div className="promo-card-circle promo-card-circle--1"></div>
            <div className="promo-card-circle promo-card-circle--2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdBanner;
